import { FMLM_BOOKING_JOURNEY_COMMENT_LEVEL, FMLM_BOOKING_JOURNEY_COMMENT_TYPE } from "../../../app/api/createBookingCommentAPI";
import { BaseAction } from "../../../core/actions/BaseAction";
import { getRecoilStateValue, updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { TripTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { IBookedJourneyDetail, IBookingComment, IJourneyStops } from "../../../Orchestrator/Types/Index";
import dayjs from 'dayjs';

interface IGetBookingCommentParams {
  bookingComments: IBookingComment[];
}

export type IGetBookingCommentResult = IBookedJourneyDetail | null

export const getJourneyStops = (trainType: TripTypeEnum = TripTypeEnum.OUT_BOUND, tripId?: string): (IJourneyStops | null) => {
  let journey = getRecoilStateValue<IBookedJourneyDetail | null>('journeyPlannerStateAtom')
  try {
    if (journey?.journey_planner && journey?.journey_planner.length > 0) {
      const getMatchJourney = (trainType: TripTypeEnum, tripId?: string) => {
        return journey?.journey_planner?.filter((j) => {
          if (trainType) return j.direction === trainType
          return true
        })
      }
      const matchJourney = getMatchJourney(trainType, tripId);

      if (!matchJourney || matchJourney.length === 0 && trainType === TripTypeEnum.IN_BOUND) {
        // This happens when trip is round trip bug no inbound journey info present (Edge case)
        let outboundJourney = getMatchJourney(TripTypeEnum.OUT_BOUND, tripId)

        // switch origin and destination for inbound
        if (!outboundJourney || outboundJourney.length === 0) return null

        let inboundJourney = structuredClone(outboundJourney[0])
        if (inboundJourney) {
          [inboundJourney.origin, inboundJourney.destination] = [inboundJourney.destination, inboundJourney.origin]
        }

        return inboundJourney || null
      }

      return matchJourney.length ? matchJourney[0] : null
    }
    return null
  } catch (error) {
    console.error("Error in getJourneyPlanner:", error);
    return null
  }
}

export const getBookedJourneyComment = (bookingComments: IBookingComment[]): IBookingComment | null => {
  return bookingComments
    .filter(i => i.type.id === FMLM_BOOKING_JOURNEY_COMMENT_TYPE && i.level.id === FMLM_BOOKING_JOURNEY_COMMENT_LEVEL)
    .sort((current, next) => {
      const currentDate = current?.lastChangeInfo?.changedOn ? dayjs(current.lastChangeInfo.changedOn) : null;
      const nextDate = next?.lastChangeInfo?.changedOn ? dayjs(next.lastChangeInfo.changedOn) : null;
      if (currentDate && nextDate) {
        if (currentDate.isBefore(nextDate)) return -1;
        if (currentDate.isAfter(nextDate)) return 1;
        return 0;
      }
      if (currentDate) return -1;
      if (nextDate) return 1;
      return 0;
    })[0] || null
}

class GetBookingJourneyDetailAction extends BaseAction<IGetBookingCommentResult, IGetBookingCommentParams> {
  override async run(): Promise<IGetBookingCommentResult> {
    let bookingJourneyDetail: IBookedJourneyDetail | null = null
    let journeyComment: IBookingComment | null = null

    try {
      const { bookingComments } = this.params!;

      journeyComment = getBookedJourneyComment(bookingComments);
      if (journeyComment) {
        let bookingJourneyDetailParsed = JSON.parse(journeyComment.comment) as IBookedJourneyDetail
        if ("journey_planner" in bookingJourneyDetailParsed) {
          bookingJourneyDetail = bookingJourneyDetailParsed
        }
      }
    } catch (error) {
      console.error("Error in GetBookingJourneyDetailAction:", error);
    } finally {
      updateRecoilState<IBookingComment | null>("bookedJourneyCommentAtom", journeyComment)
      updateRecoilState<IBookedJourneyDetail | null>("journeyPlannerStateAtom", bookingJourneyDetail)
      return bookingJourneyDetail
    }
  }
}

export const getBookingJourneyDetailAction = new GetBookingJourneyDetailAction();
